import RafThrottle from '@utilities/raf-throttle';
import uniqueID from '@utilities/uniqueID'

const JS_HOOK_BACKGROUND = '[js-hook-scroll-gradient-background]';
const JS_HOOK_CONTENT = '[js-hook-scroll-gradient-content]';
const JS_HOOK_CONTAINER = '[js-hook-scroll-gradient-container]';
const JS_HOOK_GRADIENT_LEFT = '[js-hook-scroll-gradient-left]';
const JS_HOOK_GRADIENT_RIGHT = '[js-hook-scroll-gradient-right]';

const HIDDEN_CLASS = 'u-hidden';

class ScrollGradient {
  constructor(element) {
    this.element = element;
    this.id = this.element.id;
    this.content = this.element.querySelector(JS_HOOK_CONTENT);
    this.container = this.element.querySelector(JS_HOOK_CONTAINER);
    this.background = this.element.closest(JS_HOOK_BACKGROUND);
    this.gradientLeft = this.element.querySelector(JS_HOOK_GRADIENT_LEFT);
    this.gradientRight = this.element.querySelector(JS_HOOK_GRADIENT_RIGHT);

    this.setVisiblity();

    this.bindEvents();
  }

  bindEvents() {
    RafThrottle.set([
      {
        element: this.container,
        event: 'scroll',
        namespace: `ScrollGradientNamespace_${uniqueID()}`,
        fn: () => this.setVisiblity(),
        delay: 50
      }
    ]);
  }

  setVisiblity() {
    const { width: contentWidth, left: contentLeft } = this.content.getBoundingClientRect();
    const { width: containerWidth, left: containerLeft } = this.element.getBoundingClientRect();
    const hasScrollBar = containerWidth < contentWidth;
    const position = contentLeft - containerLeft;

    if (!hasScrollBar) return;

    const leftAction = position < 0 ? 'remove' : 'add';
    this.gradientLeft.classList[leftAction](HIDDEN_CLASS);

    const rightAction = Math.round(contentWidth) + position > Math.round(containerWidth) ? 'remove' : 'add';
    this.gradientRight.classList[rightAction](HIDDEN_CLASS);
  }
}

export default ScrollGradient;
